import React, { FC, useContext, useEffect, useState } from 'react';
import { getRandomImage } from '../services/config';
import { cdnUrl } from '../constants/generic';
import SearchHistory from 'components/shared/SearchHistory';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import SearchFlight from 'components/flight/Search/SearchFlight';
import { MainContext } from 'contexts/MainContext';

const MainFlightsPage: FC = () => {
  const [bgImage, setBgImage] = useState<{ backgroundImage: string }>();
  const isEnigma = useContext(MainContext).isEnigma;

  useEffect(() => {
    if (isEnigma) return;
    (async () => {
      const response = await getRandomImage();
      setBgImage({ backgroundImage: `url(${cdnUrl + response?.imageUrl})` });
    })();
  }, []); // eslint-disable-line

  return (
    <div className="display-flex">
      <section className="main-page hotels" style={bgImage}>
        <div className="main-page-single position-relative">
          <SearchFlight loadingSearch={false} onClickStop={() => {}} />
          <SearchHistory hideArrow={true} />
        </div>
      </section>
    </div>
  );
};

export default withErrorBoundary(MainFlightsPage, 'MainFlightsPage');
